import React from "react";
import { Helmet } from "react-helmet";
import { Link, graphql, withPrefix } from "gatsby";
import Layout from "../components/Layout";

class TagRoute extends React.Component {
  render() {
    const posts = this.props.data.allMarkdownRemark.edges;
    const tag = this.props.pageContext.tag;
    const title = this.props.data.site.siteMetadata.title;
    const siteUrl = this.props.data.site.siteMetadata.siteUrl;
    const totalCount = this.props.data.allMarkdownRemark.totalCount;
    const tagHeader = `${totalCount} articulo${
      totalCount === 1 ? "" : "s"
    } relacionado con “${tag}”`;

    return (
      <Layout>
        <section className="section">
          <Helmet>
            <title>{`${tag} | ${title}`}</title>
            <meta property="og:type" content="business.business" />
            <meta property="og:title" content={title} />
            <meta property="og:url" content={siteUrl} />
            <meta
              property="og:image"
              content={`${withPrefix("/")}img/img-content.png`}
            />
          </Helmet>
          <div className="container content tags-route-page">
            <div className="columns">
              <div
                className="column is-10 is-offset-1"
                style={{ marginBottom: "3rem" }}
              >
                <header className="tags-route-hero">
                  <p className="tags-route-kicker">Etiqueta</p>
                  <h1 className="title is-size-3 is-size-4-mobile">#{tag}</h1>
                  <p className="tags-route-summary">{tagHeader}</p>
                </header>

                {posts.length > 0 ? (
                  <ul className="tags-route-posts-grid">
                    {posts.map((post, index) => (
                      <li key={post.node.fields.slug}>
                        <article className="tags-route-post-card">
                          <span className="tags-route-post-index">
                            {String(index + 1).padStart(2, "0")}
                          </span>
                          <Link
                            to={post.node.fields.slug}
                            className="tags-route-post-link"
                          >
                            <h2>{post.node.frontmatter.title}</h2>
                          </Link>
                        </article>
                      </li>
                    ))}
                  </ul>
                ) : (
                  <div className="tags-route-empty">
                    <p>Aun no hay articulos publicados con esta etiqueta.</p>
                  </div>
                )}

                <p className="tags-route-back-link-wrap">
                  <Link to="/tags/" className="button is-link is-size-6">
                    Explora todas las etiquetas
                  </Link>
                </p>
              </div>
            </div>
          </div>
        </section>
      </Layout>
    );
  }
}

export default TagRoute;

export const tagPageQuery = graphql`
  query TagPage($tag: String) {
    site {
      siteMetadata {
        title
      }
    }
    allMarkdownRemark(
      limit: 1000
      sort: { fields: [frontmatter___date], order: DESC }
      filter: { frontmatter: { tags: { in: [$tag] } } }
    ) {
      totalCount
      edges {
        node {
          fields {
            slug
          }
          frontmatter {
            title
          }
        }
      }
    }
  }
`;
